import config from 'react-native-ultimate-config';
import { isBrowser } from 'src/utils/platform';
import debugSettingsStorage from './storage/settings';
import { resolveTenancy, tenancyFromSearch } from './tenancy';
import { IDebugEnv, Tenancy } from './types';
// Dev web can pin tenancy from the URL before the first API call. Release
// builds ignore this and stay on production.
if (__DEV__ && isBrowser && typeof window !== 'undefined') {
    const tenancy = tenancyFromSearch(window.location.search);
    if (tenancy) {
        const settings = debugSettingsStorage.getSettings();
        if (settings.tenancy !== tenancy) {
            debugSettingsStorage.setSettings({
                ...settings,
                tenancy,
            });
        }
    }
}
/** Live read. Dev builds follow debug settings. Test and prod builds are locked. */
export function getTenancy() {
    switch (true) {
        case __TEST__:
            return Tenancy.TEST;
        case !__DEV__:
            return Tenancy.PROD;
        case __DEV__:
        default:
            return resolveTenancy(debugSettingsStorage.getSettings().tenancy, Tenancy.DEV);
    }
}
export const getEnv = (() => {
    const debugSettings = debugSettingsStorage.getSettings();
    return () => {
        if (__TEST__)
            return IDebugEnv.PRE_PROD;
        return __DEV__ ? debugSettings.env : IDebugEnv.PROD;
    };
})();
export const getServerURL = (() => {
    const serverURLs = {
        [IDebugEnv.DEV]: 'DEV_SERVER_URL',
        [IDebugEnv.PRE_PROD]: 'PRE_PROD_SERVER_URL',
        [IDebugEnv.PROD]: 'PROD_SERVER_URL',
    };
    return () => {
        const env = getEnv();
        return config[serverURLs[env]];
    };
})();
